import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Money, HideValuesToggle } from "@/components/HideValues";
import { PeriodPicker, PERIOD_RANGES } from "@/components/PeriodPicker";
import { toast } from "sonner";
import { Loader2, Percent } from "lucide-react";

const TABS = [{ k: "mechanics", l: "Mecânicos" }, { k: "consultants", l: "Consultores" }];

export default function OwnerCommissions() {
  const [preset, setPreset] = useState("month");
  const [[from, to], setRange] = useState(() => PERIOD_RANGES[2].range());
  const [tab, setTab] = useState("mechanics");
  const [d, setD] = useState(null);
  useEffect(() => {
    setD(null);
    api.get("/team/report", { params: { from, to } }).then(({ data }) => setD(data)).catch((e) => { toast.error(formatApiError(e)); setD({}); });
  }, [from, to]);
  const rows = d?.[tab] || [];
  const sum = (k) => rows.reduce((s, r) => s + Number(r[k] || 0), 0);
  const th = "px-3 py-2 text-left text-[11px] font-mono-caps uppercase text-zinc-500";
  return (
    <div className="space-y-5 animate-fade-up" data-testid="commissions-page">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div>
          <div className="flex items-center gap-2 text-xs font-mono-caps text-zinc-500 uppercase"><Percent className="h-4 w-4" /> Relatórios</div>
          <h1 className="font-display text-3xl font-black uppercase text-zinc-100 mt-1">Comissões</h1>
        </div>
        <HideValuesToggle />
      </div>
      <PeriodPicker preset={preset} setPreset={setPreset} from={from} to={to} setRange={setRange} testid="comm-period" />
      <div className="flex gap-2">
        {TABS.map((t) => (
          <button key={t.k} type="button" data-testid={`comm-tab-${t.k}`} onClick={() => setTab(t.k)}
            className={`h-10 px-4 rounded-full border text-sm font-bold ${tab === t.k ? "bg-green-brand text-zinc-950 border-green-brand" : "bg-zinc-900 border-zinc-800 text-zinc-300"}`}>{t.l}</button>
        ))}
      </div>
      <div className="rounded-2xl border border-card2-border bg-card2 overflow-x-auto">
        {!d ? <div className="py-10 flex justify-center"><Loader2 className="h-6 w-6 animate-spin text-green-brand" /></div> : (
          <table className="w-full text-sm" data-testid="comm-table">
            <thead><tr className="border-b border-zinc-800">
              {[tab === "mechanics" ? "Mecânico" : "Consultor", "Total vendido", "Comissão de peças", "Comissão de serviços", "Ticket médio"].map((h) => <th key={h} className={th}>{h}</th>)}
            </tr></thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.name} data-testid={`comm-row-${r.name}`} className="border-b border-zinc-900">
                  <td className="px-3 py-2 text-zinc-100 font-bold">{r.name}</td>
                  <td className="px-3 py-2 tabular-nums"><Money value={r.revenue} /></td>
                  <td className="px-3 py-2 tabular-nums"><Money value={r.comm_parts} /></td>
                  <td className="px-3 py-2 tabular-nums"><Money value={r.comm_labor} /></td>
                  <td className="px-3 py-2 tabular-nums"><Money value={r.ticket} /></td>
                </tr>
              ))}
              {!rows.length && <tr><td colSpan={5} className="px-3 py-8 text-center text-zinc-500" data-testid="comm-empty">Nenhuma OS no período.</td></tr>}
            </tbody>
            {!!rows.length && (
              <tfoot><tr className="font-bold text-zinc-100" data-testid="comm-totals">
                <td className="px-3 py-2">Total</td>
                <td className="px-3 py-2 tabular-nums"><Money value={sum("revenue")} /></td>
                <td className="px-3 py-2 tabular-nums"><Money value={sum("comm_parts")} /></td>
                <td className="px-3 py-2 tabular-nums"><Money value={sum("comm_labor")} /></td>
                <td className="px-3 py-2 tabular-nums"><Money value={sum("orders") ? sum("revenue") / sum("orders") : 0} /></td>
              </tr></tfoot>
            )}
          </table>
        )}
      </div>
    </div>
  );
}
